const RETURN_PATH_KEY = "colorthesia.auth.returnPath";

export function safeAppPath(value: unknown): string | null {
  if (typeof value !== "string" || !value.startsWith("/app")) return null;
  try {
    const url = new URL(value, window.location.origin);

    return url.origin === window.location.origin &&
      url.pathname.startsWith("/app")
      ? `${url.pathname}${url.search}${url.hash}`
      : null;
  } catch {
    return null;
  }
}

export function rememberReturnPath(path: string) {
  const safe = safeAppPath(path);

  if (safe) sessionStorage.setItem(RETURN_PATH_KEY, safe);
}

export function takeReturnPath(): string | null {
  const safe = safeAppPath(sessionStorage.getItem(RETURN_PATH_KEY));

  sessionStorage.removeItem(RETURN_PATH_KEY);

  return safe;
}
